/**
 * Order Book Page
 */

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOrderBook, cancelOrder } from '../redux/slices/orderSlice';

const OrderBook = () => {
  const dispatch = useDispatch();
  const { orderBook, loading } = useSelector((state) => state.orders);

  useEffect(() => {
    dispatch(fetchOrderBook());
    // Auto-refresh every 30 seconds
    const interval = setInterval(() => {
      dispatch(fetchOrderBook());
    }, 30000);
    return () => clearInterval(interval);
  }, [dispatch]);

  const handleCancelOrder = async (brokerOrderId) => {
    if (window.confirm('Are you sure you want to cancel this order?')) {
      await dispatch(cancelOrder(brokerOrderId));
      dispatch(fetchOrderBook());
    }
  };

  const handleRefresh = () => {
    dispatch(fetchOrderBook());
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-gray-800">Order Book</h1>
        <button onClick={handleRefresh} className="btn btn-primary">
          🔄 Refresh
        </button>
      </div>

      <div className="card">
        {loading ? (
          <p className="text-center py-8 text-gray-500">Loading orders...</p>
        ) : orderBook.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="table-auto w-full text-sm">
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Symbol</th>
                  <th>Type</th>
                  <th>Product</th>
                  <th>Qty</th>
                  <th>Price</th>
                  <th>Status</th>
                  <th>Order ID</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {orderBook.map((order, idx) => (
                  <tr key={idx}>
                    <td className="text-xs">{order.orderTime || '-'}</td>
                    <td className="font-medium">{order.tradingSymbol}</td>
                    <td className={order.transactionType === 'BUY' ? 'text-success' : 'text-danger'}>
                      {order.transactionType}
                    </td>
                    <td>{order.product}</td>
                    <td>{order.quantity}</td>
                    <td>₹{order.price}</td>
                    <td>
                      <span className={`px-2 py-1 rounded text-xs ${
                        order.orderStatus === 'COMPLETE' ? 'bg-success text-white' :
                        order.orderStatus === 'REJECTED' ? 'bg-danger text-white' :
                        order.orderStatus === 'CANCELLED' ? 'bg-gray-400 text-white' :
                        'bg-yellow-500 text-white'
                      }`}>
                        {order.orderStatus}
                      </span>
                    </td>
                    <td className="text-xs">{order.brokerOrderId}</td>
                    <td>
                      {(order.orderStatus === 'OPEN' || order.orderStatus === 'PENDING') && (
                        <button
                          onClick={() => handleCancelOrder(order.brokerOrderId)}
                          className="btn btn-danger text-xs px-2 py-1"
                        >
                          Cancel
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-center py-8 text-gray-500">No orders found</p>
        )}
      </div>
    </div>
  );
};

export default OrderBook;
